export const JQ_TOOLTIP_CONTENT = 'This option applies a JQ formula to the output of the entire '
  + 'Output Attribute expression defined above';
